import { configureStore } from '@reduxjs/toolkit';

import adminHomeReducer from '../slice/adminHomeSlice';
import appReducer from '../slice/appSlice';
import certificateIssuerHomeReducer from '../slice/certificateIssuerHomeSlice';
import certificateReceiverHomeReducer from '../slice/certificateReceiverHomeSlice';
import changePasswordReducer from '../slice/changePasswordSlice';
import corporateVerifierHomeReducer from '../slice/corporateVerifierHomeSlice';
import loggedOutHomeReducer from '../slice/loggedOutHomeSlice';
import normalUserHomeReducer from '../slice/normalUserHomeSlice';
import notificationsReducer from '../slice/notificationsSlice';
import pricingReducer from '../slice/pricingSlice';
import programsReducer from '../slice/programsSlice';
import resetPasswordReducer from '../slice/resetPasswordSlice';
import signUpReducer from '../slice/signUpSlice';
import verifyReducer from '../slice/verifySlice';

export const store = configureStore({
  reducer: {
    adminHome: adminHomeReducer,
    app: appReducer,
    certificateIssuerHome: certificateIssuerHomeReducer,
    certificateReceiverHome: certificateReceiverHomeReducer,
    changePassword: changePasswordReducer,
    corporateVerifierHome: corporateVerifierHomeReducer,
    loggedOutHome: loggedOutHomeReducer,
    normalUserHome: normalUserHomeReducer,
    notifications: notificationsReducer,
    pricing: pricingReducer,
    programs: programsReducer,
    resetPassword: resetPasswordReducer,
    signUp: signUpReducer,
    verify: verifyReducer
  }
});
